import { Avatar, Box, Button, Popover, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { pxToRem } from '../../theme/typography';
import { getAllNotifications, removeNotifications, setNotiLoad } from '../../store/notification'
import { useEffect, useState } from 'react';
import { image_url, notifications, notificationsDelete, post, notificationsDeleteAll } from '../../services/endpoints';
import { setLoading } from '../../store/load';
import { useNavigate } from 'react-router-dom';
import showToast from '../../utils/showToast'
import hit from '../../services/apiManager';
import DeleteModal from '../DeleteModal';
import useLongPress from '../../utils/useLongPress';
import moment from 'moment';
import ScoreAccessModal from '../ScoreAccessModal';
import ScoreAccessDeniedModal from '../ScoreAccessDeniedModal';

export default function NotificationPop({ anchorEl, handleClose, open, id }) {
    const dispatch = useDispatch()
    const list = useSelector(state => state?.notification?.list)
    const page = useSelector(state => state?.notification?.page)
    const totalResults = useSelector(state => state?.notification?.totalResults);
    const isloading = useSelector(state => state?.notification?.load)
    const navigate = useNavigate()
    const [notificationList, setNotificationList] = useState([])
    const [selectedArr, setSelectedArr] = useState([])
    const [selectionMode, setSelectionMode] = useState(false)
    const [deniedModal, setDeniedModal] = useState(false)
    const [deniedDetail, setDeniedDetail] = useState(null)
    const [acceptModal, setAcceptModal] = useState(false)
    const [check, setCheck] = useState(false)
    const [unselect, setUnselect] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [allNotificationArr, setAllNotificationArr] = useState([])

    useEffect(() => {
        if (open) {
            readNotifications()
            dispatch(getAllNotifications())
        }
    }, [open])

    useEffect(() => {
        setNotificationList(list)
    }, [list])

    useEffect(() => {
        if (unselect) {
            setUnselect(false)
        }
    }, [unselect])

    const getnotificationWithOutPagination = async () => {
        let res = await hit(notifications)
        if (res?.err) { } else {
            setAllNotificationArr(res?.data)
        }
    }

    useEffect(() => {
        getnotificationWithOutPagination()
    }, [])

    const readNotifications = async () => {
        const res = await hit(notifications, "patch")
        if (!res?.err) {
            dispatch(getAllNotifications())
        }
    }

    const deleteNotifications = async (arr) => {
        if (arr.length == 0) {
            showToast("No items selected", "warning")
            return
        }
        try {
            dispatch(setLoading(true))
            let res = await hit(notificationsDelete, "post", { list: arr })
            if (res?.err) {
                showToast(res?.msg, "warning")
            } else {
                // remove locally instead of refetching page 1 - keeps whatever pages/scroll
                // position were already loaded via Load More
                dispatch(removeNotifications(arr))
            }
        } catch (e) {
        } finally {
            setSelectedArr([])
            setSelectionMode(false)
            dispatch(setLoading(false))
        }
    }

    const clearAllNotifications = async () => {
        try {
            dispatch(setLoading(true))
            let res = await hit(notificationsDeleteAll, "post")
            if (res?.err) {
                showToast(res?.msg, "warning")
            }
        } catch (e) {
        } finally {
            setNotificationList([])
            dispatch(getAllNotifications())
            setSelectedArr([])
            setSelectionMode(false)
            dispatch(setLoading(false))
        }
    }

    const notiAction = async (action, item) => {
        if (action == "verify") {
            try {
                dispatch(setLoading(true))
                let res = await hit(`${post.verifyComment}/${item?.commentId}/verify`, "patch", { type: 1 })
                if (res?.err) {
                    if (res?.status == 409 || res?.status == 403) {
                        // someone else already resolved this comment while it was still showing here -
                        // drop the stale item instead of leaving a dead accept button behind
                        showToast("This request was already handled", "warning")
                        deleteNotifications([item._id])
                    } else {
                        showToast(res?.msg)
                    }
                } else {
                    if (item?.isSecondType) {
                        showToast("comment approved!!")
                        setTimeout(() => {
                            deleteNotifications([item._id])
                        }, 900);
                    } else if (res?.data?.pointsAwarded) {
                        setAcceptModal(true)
                    }

                }
            } catch (e) {
            } finally {
                dispatch(setLoading(false))
            }
        } else {
            setDeniedModal(true)
        }
    }

    const denyAcion = async (commentId, reason, notificationId) => {
        try {
            dispatch(setLoading(true))
            let res = await hit(`${post.verifyComment}/${commentId}/verify`, "patch", { type: 2, reason })
            if (res?.err) {
                if (res?.status == 409 || res?.status == 403) {
                    showToast("This request was already handled", "warning")
                    deleteNotifications([notificationId])
                } else {
                    showToast(res?.msg, "error")
                }
            } else {
                showToast("Request denied")
                setTimeout(() => {
                    deleteNotifications([notificationId])
                }, 900);
            }
        } catch (e) {
        } finally {
            dispatch(setLoading(false))
        }
    }

    return (
        <>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            sx={{ marginTop: "10px" }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}>
            <Box sx={{ maxHeight: "60vh", minWidth: "100px", overflowY: "auto" }}>
                {notificationList?.length > 0 ?
                    <>
                        {notificationList?.map((item, index) => (
                            <NotiComp
                                key={item?._id ?? index}
                                index={index}
                                item={item}
                                arr={selectedArr}
                                unselect={unselect}
                                selectionMode={selectionMode}
                                onLongPress={() => {
                                    setSelectionMode(true)
                                    if (!selectedArr.includes(item?._id)) {
                                        setSelectedArr([...selectedArr, item?._id])
                                    }
                                }}
                                onPress={() => {
                                    if (selectionMode) {
                                        if (check) {
                                            setCheck(false)
                                        }
                                        let temp = []
                                        temp = [...selectedArr]
                                        if (!temp.includes(item?._id)) {
                                            temp.push(item?._id)
                                        } else {
                                            let ind = temp.indexOf(item?._id)
                                            temp.splice(ind, 1)
                                            if (temp.length == 0) {
                                                setSelectionMode(false)
                                            }
                                        }
                                        setSelectedArr(temp)
                                    } else {
                                        if (item?.postId) {
                                            if (item?.notiType == 8) {
                                                handleClose()
                                                navigate("/user/comments", { state: { id: item?.postId?._id, groupId: item?.commentGroupId } })
                                            } else if (item?.notiType != 9) {
                                                if (item?.postId?.isScorePost == false && item?.postId?.isApproved == 0) {
                                                    return
                                                }
                                                handleClose()
                                                navigate("/user/post_detail", { state: { id: item?.postId?._id, groupId: item?.groups?.[0] } })
                                            }
                                        }
                                    }
                                }}
                                onPressVerify={() => {
                                    setDeniedDetail(item)
                                    notiAction("verify", item)
                                }}
                                onPressDeny={() => {
                                    setDeniedDetail(item)
                                    notiAction("deny", item)
                                }}
                            />
                        ))}
                    </>
                    :
                    <Typography sx={{ py: 3, textAlign: 'center' }}>No Notifications !</Typography>
                }
                {!isloading ?
                    <Box
                        sx={{ width: "400px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        {totalResults > list?.length &&
                            <Button
                                onClick={() => {
                                    dispatch(setNotiLoad(true))
                                    dispatch(getAllNotifications(10, page + 1))
                                }}
                                sx={{ marginTop: "20px", color: "#58C0DC" }}
                                variant="outline">
                                Load More
                            </Button>
                        }
                    </Box> :
                    <Box
                        sx={{ width: "400px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src='assets/loader1.gif' alt="Loading" style={{ height: "40px" }} />
                    </Box>
                }
            </Box>
            {(notificationList?.length > 0 && true) &&
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingInline: 18 }}>
                    <Typography 
                        onClick={() => {
                            if (selectionMode) {
                                deleteNotifications(selectedArr)
                                setSelectionMode(false)

                            }
                            else {
                                setSelectionMode(true)

                            }
                        }} 
                        color={"primary"} 
                        sx={{ cursor: "pointer", fontSize: pxToRem(12), fontWeight: "600", textAlign: "center", marginY: "20px" }}>
                            {selectionMode ? "Delete selected items (" + selectedArr?.length + ")" : "Select Items"}
                    </Typography>
                    {selectionMode && 
                    <Typography 
                        onClick={() => {
                            setSelectedArr([])
                            setUnselect(true)
                            setSelectionMode(false)
                        }} 
                        color={"primary"} 
                        sx={{ cursor: "pointer", fontSize: pxToRem(12), fontWeight: "600", textAlign: "center", marginY: "20px" }}>Cancel
                    </Typography>}
                    <Typography 
                        onClick={() => {
                            setDeleteModal(true)
                            let temp = []
                            allNotificationArr.forEach((e) => {
                                temp.push(e?._id)
                            })
                            setSelectedArr(temp)
                        }} 
                        color={"primary"} 
                        sx={{ cursor: "pointer", fontSize: pxToRem(12), fontWeight: "600", textAlign: "center", marginY: "20px" }}>
                            Clear All
                    </Typography>
                </div>
            }
        </Popover>
            <DeleteModal
                title={"You want to delete notifications?"}
                open={deleteModal}
                handleClose={() => { setDeleteModal(false); setSelectedArr([]); setUnselect(true) }}
                onPressNo={() => { setDeleteModal(false); setSelectedArr([]); setUnselect(true) }}
                onPressYes={() => { setDeleteModal(false); clearAllNotifications(); }}
            />
            <ScoreAccessModal open={acceptModal} setOpen={setAcceptModal} detail={deniedDetail}
                onPressOk={(id) => {
                    deleteNotifications([id])
                    setAcceptModal(false)
                }} />
            <ScoreAccessDeniedModal open={deniedModal} setOpen={setDeniedModal} detail={deniedDetail}
                onPressOk={(r, data) => {
                    setDeniedModal(false)
                    denyAcion(data?.commentId, r, data?._id)
                }}
                outPressed={() => {
                    setDeniedModal(false)
                }} />
        </>
    );
}

const NotiComp = ({ item, index, onLongPress, arr, onPress, onPressVerify, onPressDeny, unselect, selectionMode }) => {
    const [isIncluded, setIsIncluded] = useState(false)

    useEffect(() => {
        if (arr.includes(item?._id)) {
            setIsIncluded(true)
        }
    }, [arr])

    useEffect(() => {
        if (unselect) {
            setIsIncluded(false)
        }
    }, [unselect])

    let name = []

    if (item?.body?.includes("group")) {
        let n = item?.body?.split("group")
        name = [...n]
    }

    const longPress = useLongPress();
    const isScoreNoti = item?.body?.toLowerCase()?.includes("scored")
    const accentColor = isScoreNoti ? "#F5A623" : item?.notiType == "8" ? "#0DB1D4" : "#8E6FF7"

    return (
        <Box
            onClick={() => {
                onPress(item?._id)
                setIsIncluded(false)
            }}
            {...longPress(() => {
                onLongPress(item?._id);
                setIsIncluded(true)
            })}
            sx={{
                cursor: "pointer", position: "relative", p: "14px", borderRadius: "16px", width: "400px",
                display: "flex", gap: "12px", background: "white", marginX: "10px", marginTop: "14px",
                boxShadow: "0px 4px 14px #26262620", border: "1px solid #26262610",
                transition: "box-shadow 0.15s ease, transform 0.15s ease",
                ":hover": { boxShadow: "0px 6px 18px #26262230", transform: "translateY(-1px)" },
            }}>
            <Box sx={{ position: "relative", flexShrink: 0 }}>
                {(selectionMode && isIncluded == false)
                    ? <Avatar sx={{ height: "44px", width: "44px", boxShadow: `0px 3px 8px ${accentColor}55` }} src={"assets/notifications/u.svg"} />
                    : <Avatar sx={{ height: "44px", width: "44px", boxShadow: `0px 3px 8px ${accentColor}55`, border: `2px solid ${accentColor}` }} src={isIncluded == true ? "assets/notifications/s.svg" : image_url + item?.refUsers[0]?.profilePic} />}
                {isScoreNoti &&
                    <Box sx={{
                        position: "absolute", bottom: -2, right: -2, height: "18px", width: "18px", borderRadius: "50%",
                        background: accentColor, display: "flex", alignItems: "center", justifyContent: "center",
                        boxShadow: "0px 2px 4px #00000033", fontSize: "10px",
                    }}>🏆</Box>
                }
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 0 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "8px" }}>
                    {name?.length == 0 ? <Typography sx={{ fontSize: pxToRem(13.5), fontWeight: "500", lineHeight: 1.5, color: "#2b2b2b" }}>{item?.body}</Typography>
                        :
                        <Typography sx={{ fontSize: pxToRem(13.5), fontWeight: "500", lineHeight: 1.5, color: "#2b2b2b" }}>{`${name[0]}group`}<Typography component={"span"} sx={{ fontSize: pxToRem(13.5), fontWeight: "700", color: accentColor }}>{`${name[1]}`}</Typography></Typography>
                    }
                </Box>
                <Typography sx={{ fontSize: pxToRem(10.5), color: "#26262688", marginTop: "6px", fontWeight: "600" }}>{moment(item?.createdAt).format("Do MMM, hh:mm a")}</Typography>
                {item?.notiType == "8" &&
                    <Box sx={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "8px", marginTop: "10px" }}>
                        <Button title={""}
                            variant="contained"
                            sx={{
                                height: 28, minWidth: "76px", px: "14px", fontSize: pxToRem(10.5), fontWeight: "700", borderRadius: "16px", textTransform: "none",
                                background: "linear-gradient(135deg, #FF6B6B, #E14545)", boxShadow: "0px 3px 8px #E1454540",
                            }}
                            onClick={(e) => {
                                e.stopPropagation()
                                onPressDeny()
                            }} >
                            Deny
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                height: 28, minWidth: "76px", px: "14px", fontSize: pxToRem(10.5), fontWeight: "700", borderRadius: "16px", textTransform: "none",
                                background: "linear-gradient(135deg, #4CBB5A, #3EA24A)", boxShadow: "0px 3px 8px #3EA24A40",
                            }}
                            onClick={(e) => {
                                e.stopPropagation()
                                onPressVerify()
                            }} >
                            Verify
                        </Button>
                    </Box>
                }
            </Box>
        </Box>
    )
}